const oneBtcInSatoshi = 100000000
let currentDate = new Date();
let btcPriceEur = document.getElementById("current-btc-eur")
let btcPriceUsd = document.getElementById("current-btc-usd")
let btcPriceItems = document.getElementsByClassName("price-in-bitcoin")

function setCurrentPrices(btcEur, btcUsd) {
    if (btcPriceEur != null && btcEur != null) {
        btcPriceEur.innerHTML = "Bitcoin in EUR: " + btcEur
    }
    if(btcPriceUsd != null && btcEur != null) {
        btcPriceUsd.innerHTML = "Bitcoin in USD: " + btcUsd
    }
}

function readCookieValue(name) {
    let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) {
        return match[2]
    } else {
        console.log('--something went wrong---');
    }
}

function setBtcPrices(update, prices) {
    if (update) {
        let futureDate = new Date(currentDate.getTime() + 280000);
        localStorage.setItem('lastPriceFetch', futureDate);
        localStorage.btcprices = JSON.stringify(prices);
    }
    let currency = readCookieValue('cart_currency')
    //console.log("Currency", currency)
    applyPrices(currency)
}

function applyPrices(pair) {
    let btcPrices = JSON.parse(localStorage.btcprices);
    let btcPriceItem = btcPrices.data.find(item => item.code === pair)
    //console.log("btcPriceItem: ", btcPriceItem)
    /* 1 BTC in Satoshi / Current BTC Price in Cent = Satoshi per cent */
    let satoshiPerCent = oneBtcInSatoshi / (btcPriceItem.rate * 100)
    //console.log("satoshiPerCent: ", satoshiPerCent)
    for (let i = 0; i < btcPriceItems.length; i++) {
        let productPrice = btcPriceItems[i].getAttribute("data-price")
        //console.log("productPrice: ", productPrice)
        let productPriceInSatoshi = satoshiPerCent * productPrice
        //console.log("productPriceInSatoshi: ", productPriceInSatoshi)
        btcPriceItems[i].innerHTML = "<i class='fak fa-satoshisymbol-solidcirtilt'>" + " " + Math.round(productPriceInSatoshi)
    }
    //set global price
    let btcPriceUsd = btcPrices.data.find(item => item.code === "EUR")
    let btcPriceEur = btcPrices.data.find(item => item.code === "USD")
    setCurrentPrices(btcPriceUsd.rate, btcPriceEur.rate)
}

let setI = setInterval(timer, 300000)

function timer(){
    checkLatestFetch()
}

function fetchData() {
    fetch("https://bitpay.com/rates/").then(response => {
            if (!response.ok) {
                throw new Error('Request failed with status' + response.status)
            }
            return response.json()
        }).then(data => {
            setBtcPrices(true, data)
        }).catch(error => console.log(error))
}

function checkLatestFetch() {
    let lastPriceFetch = localStorage.getItem('lastPriceFetch');
    let lastPriceFetchDate
    if (lastPriceFetch != null) {
        try {
            lastPriceFetchDate = new Date(lastPriceFetch);
        } catch (e) {
            console.log(e)
        }
    }
    //console.log("LPF", lastPriceFetch, "LPFD", lastPriceFetchDate, "CD", currentDate)
    if (lastPriceFetch == null || localStorage.btcprices == null || lastPriceFetchDate < currentDate) {
        fetchData()
    } else {
        setBtcPrices(false, '')
    }
}

document.addEventListener('DOMContentLoaded', (event) => {
    checkLatestFetch()
});
